/* eslint-disable */
// prettier-ignore
export default {
  "terms": [{
    "term": "blacklist",
    "alternative_terms": ["block list", "exclusion list", "unapproved list", "deny list"],
    "description": "Applies a negative connotation to things that are black and a positive connotation to those that are white.",
    "regex": {
      "java": "(?i)black[-_ ]?list",
      "javascript": "black[-_ ]?list",
      "ruby": "black[-_ ]?list",
      "python": "black[-_ ]?list"
    }
  }, {
    "term": "whitelist",
    "alternative_terms": ["safe list", "inclusion list", "approved list", "allow list"],
    "description": "Applies a negative connotation to things that are black and a positive connotation to those that are white.",
    "regex": {
      "java": "(?i)white[-_ ]?list",
      "javascript": "white[-_ ]?list",
      "ruby": "white[-_ ]?list",
      "python": "white[-_ ]?list"
    }
  }, {
    "term": "black days",
    "alternative_terms": ["blocked days"],
    "description": "Applies a negative connotation to things that are black and a positive connotation to those that are white.",
    "regex": {
      "java": "(?i)black[-_ ]?day",
      "javascript": "black[-_ ]?day",
      "ruby": "black[-_ ]?day",
      "python": "black[-_ ]?day"
    }
  }, {
    "term": "white days",
    "alternative_terms": ["clear days"],
    "description": "Applies a negative connotation to things that are black and a positive connotation to those that are white.",
    "regex": {
      "java": "(?i)white[-_ ]?day",
      "javascript": "white[-_ ]?day",
      "ruby": "white[-_ ]?day",
      "python": "white[-_ ]?day"
    }
  }, {
    "term": "slave",
    "alternative_terms": ["replica", "secondary", "follower", "responder"],
    "description": "Evokes images of slavery and racist social structures.",
    "regex": {
      "java": "(?i)slave",
      "javascript": "slave",
      "ruby": "slave",
      "python": "slave"
    }
  }]
};